





































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

@Component({
    components: {

    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PositionController extends Vue 
{
    // ボタン長押し対応
    private pressed = false;
    private timers : Array<number> = [];
    private pressedDuration = 0;
    private isChangingValue = false;

    private onClick(dx : number, dy : number, dRotate : number = 0, dWidth : number = 0, dHeight : number = 0)
    {
        this.$emit("doCommand", "moveSelectedLayerDelta", { dx : dx, dy : dy, dRotate : dRotate, dWidth : dWidth, dHeight : dHeight, isOnce : true, isFinish : true });
    }

    private onPress(dx : number, dy : number, dRotate : number = 0, dWidth : number = 0, dHeight : number = 0)
    {
        this.pressed = true;
        this.timers.push(setInterval(() =>
        {
            if(this.pressed)
            {
                if(this.pressedDuration > 3)
                {
                    this.$emit("doCommand", "moveSelectedLayerDelta", { dx : dx, dy : dy, dRotate : dRotate, dWidth : dWidth, dHeight : dHeight, isOnce : false, isFinish : false });
                    this.isChangingValue = true;
                }
            }
            this.pressedDuration++;
        }, 100));
    }

    private resetPress()
    {
        this.pressed = false;
        this.pressedDuration = 0;
        for(var i = 0; i < this.timers.length; ++i)
        {
            var timer = this.timers[i];
            clearInterval(timer);
        }
        this.timers = [];
        if(this.isChangingValue)
        {
            this.$emit("doCommand", "moveSelectedLayerDelta", { dx : 0, dy : 0, dRotate : 0, dWidth : 0, dHeight : 0, isOnce : false, isFinish : true });
        }
        this.isChangingValue = false;
    }
}
